'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validPhoneWay = exports.resetPasswords = exports.routerAfterEach = exports.routerBeforeEach = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _iview = require('iview');

var _iview2 = _interopRequireDefault(_iview);

var _axios = require('@/plugins/axios');

var _axios2 = _interopRequireDefault(_axios);

var _config = require('@/config');

var _getlang = require('./getlang');

var _getlang2 = _interopRequireDefault(_getlang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var whiteRouterName = ['index', 'login', 'retrieve', 'applicationSecret', 'techAuth', 'livePlay', 'speedTest', 'appPolymer', 'appDownload', 'websitedownload'];
var recordVisit = function recordVisit(to) {
  (0, _axios2.default)({
    url: '/user/event/visit',
    data: {
      origin: 'PC',
      page: to.name
    },
    method: 'GET'
  });
};
var routerBeforeEach = exports.routerBeforeEach = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(to, from, resolve) {
    var token, weakPassword;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // record page visit
            recordVisit(to);
            _context.next = 3;
            return (0, _getlang2.default)();

          case 3:
            token = localStorage.getItem('token');

            if (!(!token && !whiteRouterName.includes(to.name))) {
              _context.next = 9;
              break;
            }

            resolve({ path: '/' });
            return _context.abrupt('return');

          case 9:
            if (!(token && token !== 'null' && to.name === 'login')) {
              _context.next = 12;
              break;
            }

            //未登录状态，重定向到首页
            resolve(_config.indexRouter);
            return _context.abrupt('return');

          case 12:
            _iview2.default.LoadingBar.start();
            localStorage.removeItem('playToken');
            weakPassword = 1;

            if (!token && !whiteRouterName.includes(to.name)) {
              localStorage.removeItem('playToken');
            } else {
              if (!whiteRouterName.includes(to.name)) {
                (0, _axios2.default)({
                  url: '/api-ouser/portal/user/getCurrentUser',
                  method: 'GET'
                }).then(function (_ref2) {
                  var data = _ref2.data;

                  localStorage.setItem('loginID', data.data.account.userName);
                  resetPasswords(to, from, resolve, weakPassword);
                });
              } else {
                localStorage.removeItem('playToken');
                resolve();
              }
            }

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function routerBeforeEach(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var routerAfterEach = exports.routerAfterEach = function routerAfterEach(to, from) {
  _iview2.default.LoadingBar.finish();
};
var resetPasswords = exports.resetPasswords = function resetPasswords(to, from, resolve, weakPassword) {
  if (weakPassword) {
    if (weakPassword == 2 && to.name !== 'emailReset') {
      alert('当前密码为弱密码,请你修改密码');
      resolve({ path: '/emailReset' });
      return;
    }
    localStorage.removeItem('playToken');
  } else {
    if (to.name !== 'login' && to.name !== 'retrieve' && to.name !== 'emailReset') {
      (0, _axios2.default)({
        url: '/api-ouser/portal/user/account/checkWeakPasswd',
        method: 'PUT',
        data: {
          loginID: localStorage.getItem('loginID')
        }
      }).then(function (_ref3) {
        var data = _ref3.data;

        if (data.data) {
          localStorage.setItem('weakPassword', 2);
          alert('当前密码为弱密码,请你修改密码');
          resolve({ path: '/emailReset' });
          return;
        }
        localStorage.setItem('weakPassword', 1);
        localStorage.removeItem('playToken');
      });
    } else {
      localStorage.removeItem('playToken');
    }
  }
  resolve();
};
var validPhoneWay = exports.validPhoneWay = function validPhoneWay(to, from, resolve, validPhone) {
  if (validPhone) {
    // if (validPhone == 2 && to.name !== 'validPhone') {
    //   resolve({path: '/validPhone'})
    //   return
    // }
    localStorage.removeItem('playToken');
  } else {
    if (to.name !== 'login' && to.name !== 'validPhone') {
      localStorage.setItem('validPhone', 1);
      // axios({
      //   url: `user/isInternet`,
      //   method: 'get'
      // }).then(({data}) => {
      //   // if (data.data) {
      //   //   localStorage.setItem('validPhone', 2)
      //   //   resolve({path: '/validPhone'})
      //   //   return
      //   // }
      //   // localStorage.setItem('validPhone', 1)
      //   // localStorage.removeItem('playToken')
      // })
    } else {
      localStorage.removeItem('playToken');
    }
  }
  resolve();
};